import { use, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';


const AuthErrorReset = () => {
  const { setAuthError } = useAuth();
  const location = useLocation();

  useEffect(() => {
    setAuthError(null);
  }, [location.pathname]);

  return null;
};

export default AuthErrorReset;